import * as $ from 'jquery';
import * as ko from 'knockout';

declare var DobryKantor: any;

export class BanksComponent {
    index: ko.Observable<number>;
    timer: any;

    executeTimer() {
        this.timer = setTimeout(() => {
            this.index(this.index() % 5 + 1);
            this.executeTimer();
        }, 3000);
    }

    constructor() {
        this.index = ko.observable(1);
        this.executeTimer();
    }

    isCurrentIndex(index: any) {
        return this.index() === index;
    }
}
